<template>
  <div>
    <OverlayViewer />
    <v-app-bar
      app
      :clipped-right="$vuetify.breakpoint.mobile"
      class="d-flex align-center justify-center"
    >
      <v-btn icon v-if="renderBackButton" class="pa-0" style="width: 64px" @click="historyBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn icon v-else class="pa-0" style="visibility: hidden; width: 64px">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="pl-0">
        <LogoText size="28px" class="text-center" white mainLink />
      </v-toolbar-title>
      <v-app-bar-nav-icon style="width: 64px" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app right fixed temporary>
      <Left v-if="isAuthenticated === true" />
      <LeftUnauth v-else />
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Left from './Left.vue'
import LeftUnauth from './LeftUnauth.vue'
import OverlayViewer from '@/components/overlay/OverlayViewer.vue'

export default {
  components: {
    Left,
    LeftUnauth,
    OverlayViewer,
  },
  data() {
    return {
      drawer: false,
      excludeBack: {
        names: ['main', 'signup', 'my/register/complete', 'terms/detail', 'terms/detail/privacy'],
        prefixes: ['/landing'],
      },
      includeLogin: {
        names: ['main'],
        prefixes: ['/landing'],
      },
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    renderBackButton() {
      const excludedName = this.excludeBack.names.some((n) => n === this.$route.name)
      const excludedPrefix = this.excludeBack.prefixes.some((n) => this.$route.path.startsWith(n))
      return !excludedName && !excludedPrefix
    },
    renderLoginButton() {
      if (this.isAuthenticated) {
        return false
      }
      const includedName = this.includeLogin.names.some((n) => n === this.$route.name)
      const includedPrefix = this.includeLogin.prefixes.some((n) => this.$route.path.startsWith(n))
      return includedName || includedPrefix
    },
  },
  watch: {
    isAuthenticated(nv, ov) {
      // 로그아웃시에 비활성화
      if (ov === true && nv === false) {
        this.drawer = false
      }
    },
  },
  methods: {
    historyBack() {
      if (!this.isMain) {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
header {
  background-color: $main-color-default !important;
}

::v-deep .v-toolbar__content {
  max-width: $standard-max-width;
  width: 100%;
  justify-content: space-between;

  padding-left: 12px;
  padding-right: 12px;
}

.v-toolbar__title {
  width: 100%;
}

.login-btn {
  background-color: #ffffff;
}
</style>
